import { Header } from '@/components/Header/Header';
import { BottomBar } from '@/components/BottomBar/BottomBar';

/**
 * Временный placeholder маршрутов Блока 8, ещё не реализованных в D1:
 * `/partners/list` (экран 2.8.2 — Фаза D2) и `/partners/review` (форма 2.8.4 — Фаза E).
 * Нужен, чтобы навигация с экрана категорий не давала битых ссылок до D2/E.
 * Layout shell P-046; «Назад» — история (P-036, BottomBar/Header).
 */
export function PartnersPlaceholder({ title }: { title: string }) {
  return (
    <main className="min-h-screen flex flex-col bg-canvas">
      <Header title={title} />
      <section className="flex-1 overflow-y-auto flex items-center justify-center p-6">
        <p className="font-display text-h2 text-ink text-center">Скоро</p>
      </section>
      <BottomBar />
    </main>
  );
}
